import { ISolicitudAmpliarPersonalModel } from "../interfaces/solicitud/ISolicitudAmpliarPersonalModel";

export class SolicitudAmpliarPersonalModel implements ISolicitudAmpliarPersonalModel {
    idSolicitud : number;
    comentarios: string;

    constructor(){
        this.idSolicitud = 0;
        this.comentarios = '';
    }
}